// import store from '@/store';
// import moment from "moment";
import consts from "@/consts";

const defaultSettings = {
    statistics: (route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.statistics.main) {
            if(consts.app.$isDevelopment) console.warn('statistics', route);
            return false
        }
        router.push({
            name: consts.routerNames.statistics.main,
            params: {},
            query: {}
        })
    },
}

const routes = (process.env.VUE_APP_PACKAGE !== 'prometheus.admin') ? [] : [
    {
        path: 'statistics',
        name: consts.routerNames.statistics.main,
        meta: {
            mainRouteName: consts.routerNames.statistics.main,
            bodyGrid: "1X1",
            setRoute: defaultSettings,
        },
        component: () => import('@/views/prometheus/admin/StatisticsPage.vue'),
        children: [
        ]
    },
];

export default routes;